import "datatables.net"
import "datatables.net-bs4"
import "datatables.net-buttons"
import "datatables.net-buttons-bs4"
import "datatables.net-buttons/js/buttons.html5"
import "datatables.net-buttons/js/buttons.colVis"
import {handleRowClick, prepareHeader} from "./shared";

/*
    Funkcja przypina dynamicznie Datatables do elementu .dataTable.
    Ustawia na tej tabeli różne początkowe elementy dotyczące wyglądu i komunikacja ajaxowej z backendem.
 */
export function attachDataTablesCompleted(context, paginationUrl, pageLength) {
    const $context = $(context);
    $context.find('.dataTable').each(function() {
        let dt = $(this).DataTable({
            "pageLength": pageLength,
            order: [[8, 'desc']],
            dom: '<"top">rt<"bottom"flpi><"clear">',
            drawCallback: function(){
                $($('.dataTable')[0]).show();
                $("tr.odd > td:nth-child(1), tr.even > td:nth-child(1)").prepend('<em class="bx bx-plus-circle font-size-16 mr-2"></em>');
            },
            initComplete: function () {
                prepareHeader(this.api(), 3);
                $('td.filterHead:nth-child(1) > input:nth-child(1)').addClass('ajax_search_name');
                $('td.filterHead:nth-child(2) > input:nth-child(1)').addClass('ajax_search_category');
                $('td.filterHead:nth-child(3) > input:nth-child(1)').addClass('ajax_search_author');
                $('td.filterHead:nth-child(4) > input:nth-child(1)').addClass('ajax_search_count_of_complete');
                $('td.filterHead:nth-child(5) > input:nth-child(1)').addClass('ajax_search_tag');
                $('td.filterHead:nth-child(6) > input:nth-child(1)').addClass('ajax_search_created_at');
                $('td.filterHead:nth-child(7) > input:nth-child(1)').addClass('ajax_search_changed_at');
                $('td.filterHead:nth-child(8) > input:nth-child(1)').addClass('ajax_search_changed_by');
                $('.column_search').addClass('form-control').addClass('outline-none').addClass('border-width-zero');
                $('.dataTable > thead:nth-child(1) > tr:nth-child(2) > td:nth-child(9)').css({ 'min-width': '150px', 'max-width': '150px' });
                $('.dataTable > tbody:nth-child(2)').css({'cursor': 'pointer'});
                $('select.outline-none').addClass('border-width-zero');
                $('[data-toggle="tooltip"]').tooltip({
                    show: { duration: 500 }
                });
            },
            "rowCallback": function( row, data ) {
                handleRowClick(row, dt, data);
            },
            'searching': true,
            "searchCols": [
                { "data": 'name'},
                { "data": 'category'},
                { "data": 'author' },
                { "data": 'count_of_complete' },
                { "data": 'tag' },
                { "data": "created_at"},
                { "data": "changed_at"},
                { "data": "changed_by"},
                null

            ],
            'columns': [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ],
            'paging': true,
            'processing': true,
            'serverSide': true,
            'serverMethod': 'get',
            'lengthMenu': [5, 10, 25, 50],
            'ajax': {
                'url': paginationUrl
            },
            language: {
                paginate: {
                    previous: '<i class="bx bx-chevron-left font-size-16 align-middle mr-2"></i>',
                    next: '<i class="bx bx-chevron-right font-size-16 align-middle mr-2"></i>',
                    first: '<i class="bx bx-first-page font-size-16 align-middle mr-2"></i>',
                    last: '<i class="bx bx-last-page font-size-16 align-middle mr-2"></i>'
                },
                info: "Displaying _START_ - _END_ of _TOTAL_ results",
                infoEmpty: "No entries to show"
            },
            columnDefs: [
                {
                    targets: 'no-sort',
                    orderable: false
                },
                {
                  targets: 0,
                  visible: false,
                  searchable: false
                },
                {
                    targets: 1,
                    visible: false,
                    searchable: false
                },
                {
                    targets: 2,
                    "width": "50%"
                },
                {
                    targets: 10,
                    "width": "14%"
                },
                {
                    targets: 10,
                    className: "disabled_details",
                    render: function (data, type, row, meta) {
                        let out = `
                        <div class="conditional_icons_container disabled_details">
                             <a href="${row[0]}/report/summary"
                               class="text-success mr-2" data-toggle="tooltip" data-placement="top"
                               title="Show" data-original-title="Show">
                               <i class="bx bx-show-alt font-size-22 disabled_details"></i>
                            </a> 
                            <a href="${row[0]}/copy"
                               class="text-primary mr-2 showCopySurveyPopup" data-toggle="tooltip" data-placement="top"
                               title="Copy" data-original-title="Copy">
                               <i class="bx bx-copy font-size-22 disabled_details"></i>
                            </a> 
                            <a href="/panel/survey/ajax/${row[0]}"
                                onclick="event.preventDefault(); handleSweetAlertModal(event, 'DELETE');"
                                data-original-title="Remove"
                                data-alert-id="1"
                                data-alert-link=""
                                data-alert-title="Are you sure?"
                                data-alert-text="You won't be able to revert this!"
                                data-alert-button="Remove Survey"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-alert-icon="question"
                                data-alert-confirm-button-text='<i class="label-icon bx bx-trash"></i> Delete'
                                data-alert-confirm-button-class="btn btn-label btn-danger btn-min-width"
                                data-alert-cancel-button-text='<i class="label-icon bx bx-arrow-back"></i> Cancel'
                                data-alert-cancel-button-class="btn btn-label btn-primary btn-min-width"
                                class="secured text-danger">
                                <i class="bx bx-trash font-size-22 disabled_details"></i>
                            </a> 
                        `;
                        if (row[1].restore) {
                           out += `
                            <a href="/panel/survey/${row[0]}/status/restore"
                                title="Reopen" data-original-title="Reopen"
                                data-toggle="tooltip" data-placement="top"
                                class="text-danger restoreSurveyButton">
                                <i class="bx bx-revision font-size-22 disabled_details"></i>
                            </a> 
                           `;
                        }
                        let canCreateSurvey = $(document).find('input#canCreateSurvey').val();
                        if (canCreateSurvey) {
                            if (row[1].create_new_wave) {
                                out +=  `
                                <a href="/panel/survey/${row[0]}/create-new-wave" class="text-primary mr-2" data-toggle="tooltip" data-placement="top" title="Create new wave" data-original-title="Create new wave">
                                    <i class="bx bx-skip-next-circle font-size-22 disabled_details"></i>
                                </a>
                            `;
                            }
                        } else {
                            out +=  `
                                <a href="/panel/survey/${row[0]}/create-new-wave" class="text-dark mr-2" data-toggle="tooltip" data-placement="top" title="Create new wave - Suspended" data-original-title="Create new wave - Suspended">
                                    <i class="bx bx-skip-next-circle font-size-22 disabled_details"></i>
                                </a>
                            `;
                        }
                        out += `</div>`;
                        return out;
                    }
                }
            ]
        });
    });
    $context.find('.data-table-column-search').on('click', function (e) {
        e.stopPropagation();
    });
}

